export default function CallToAction() {
  return (
    <>
      <h2 className="call-to-action__message">Boost your links today</h2>
      <button className="btn btn--accent">Get Started</button>
    </>
  );
}